export const DEFAULT_REACT_ARTIFACT_CODE = `function App() {
  const [count, setCount] = React.useState(0);
  
  const data = [
    { name: 'High Priority', value: 4, color: '#ef4444' },
    { name: 'Medium Priority', value: 10, color: '#f97316' },
    { name: 'Low Priority', value: 22, color: '#22c55e' },
  ];

  const totalFields = 36;
  const duplicateFields = 9;
  const newestFields = 5;

  return (
    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
      <h1>Opportunity Object Field Cleanup Analysis</h1>
      <p>Analysis of fields requiring cleanup attention including duplicates, unused fields, and recent additions</p>
      
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '20px', marginBottom: '30px' }}>
        <div style={{ padding: '20px', backgroundColor: '#f8fafc', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
          <h3>Total Fields Analyzed</h3>
          <div style={{ fontSize: '24px', fontWeight: 'bold' }}>{totalFields}</div>
        </div>
        <div style={{ padding: '20px', backgroundColor: '#fef2f2', borderRadius: '8px', border: '1px solid #fecaca' }}>
          <h3>High Priority</h3>
          <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#dc2626' }}>4</div>
        </div>
        <div style={{ padding: '20px', backgroundColor: '#fff7ed', borderRadius: '8px', border: '1px solid #fed7aa' }}>
          <h3>Duplicate Fields</h3>
          <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#ea580c' }}>{duplicateFields}</div>
        </div>
        <div style={{ padding: '20px', backgroundColor: '#f0fdf4', borderRadius: '8px', border: '1px solid #bbf7d0' }}>
          <h3>Newest Fields</h3>
          <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#16a34a' }}>{newestFields}</div>
        </div>
      </div>

      <h2>Cleanup Priority Distribution</h2>
      <div style={{ display: 'flex', alignItems: 'center', gap: '40px', marginBottom: '30px' }}>
        <div style={{ width: '200px', height: '200px', borderRadius: '50%', position: 'relative', background: 'conic-gradient(#22c55e 0deg 220deg, #f97316 220deg 320deg, #ef4444 320deg 360deg)' }}>
        </div>
        <div>
          {data.map((item, index) => (
            <div key={index} style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
              <div style={{ width: '16px', height: '16px', backgroundColor: item.color, borderRadius: '50%' }}></div>
              <span>{item.name}: {item.value}</span>
            </div>
          ))}
        </div>
      </div>

      <h2>Interactive Counter Example</h2>
      <div style={{ padding: '20px', backgroundColor: '#f1f5f9', borderRadius: '8px', textAlign: 'center' }}>
        <p>Count: {count}</p>
        <button 
          onClick={() => setCount(count + 1)}
          style={{ 
            padding: '10px 20px', 
            backgroundColor: '#3b82f6', 
            color: 'white', 
            border: 'none', 
            borderRadius: '6px', 
            cursor: 'pointer',
            marginRight: '10px'
          }}
        >
          Increment
        </button>
        <button 
          onClick={() => setCount(0)}
          style={{ 
            padding: '10px 20px', 
            backgroundColor: '#6b7280', 
            color: 'white', 
            border: 'none', 
            borderRadius: '6px', 
            cursor: 'pointer'
          }}
        >
          Reset
        </button>
      </div>
    </div>
  );
}`;
